import { render, staticRenderFns } from "./CreatedPopup.vue?vue&type=template&id=0df33e60&"
import script from "./CreatedPopup.vue?vue&type=script&lang=js&"
export * from "./CreatedPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports